module.exports = __webpack_public_path__ + "static/media/mobile-inactive.f38c19d6.svg";